import { UsersService } from './../../shared/services/users.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MatLegacyAutocomplete as MatAutocomplete,
  MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { Router } from '@angular/router';
import { Address } from '@classes/address';
import { Client } from '@classes/client';
import { Dictionary } from '@classes/dictionary/dictionary';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { RecurringOrder } from '@classes/recurring-order/recurring-order';
import { Site } from '@classes/site';
import { User } from '@classes/user/user';
import { ConfirmValidMatcher } from '@classes/validations/confirm-valid-matcher';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { Day } from '@enums/days.enum';
import { OrderType } from '@enums/order-type.enum';
import { RoleName } from '@enums/role-name.enum';
import { AddressesService } from '@services/addresses.service';
import { AuthService } from '@services/auth.service';
import { ClientsService } from '@services/clients.service';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { RecurringOrdersService } from '@services/recurring-orders.service';
import { SitesService } from '@services/sites.service';
import { UiService } from '@services/ui.service';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-recurring-order-create',
  templateUrl: './recurring-order-create.component.html',
  styleUrls: ['./recurring-order-create.component.scss'],
})
export class RecurringOrderCreateComponent
  extends FormEditBaseComponent
  implements OnInit
{
  clients: Client[];
  sites: Site[];
  filteredSites: Site[] = [];
  selectedClient: Client;
  allTransportTypes: DictionaryValue[];
  urgencyLevels: DictionaryValue[];
  senders: Address[];
  receivers: Address[];
  drivers: User[];

  order: RecurringOrder;

  stringMaxLength = 50;
  commentMaxLength = 500;
  codeMaxLength = 20;
  isRestricted: boolean;
  isClient: boolean;
  isAdmin: boolean;
  isAdminWithOneClient: boolean;
  mustCheckDate: boolean;
  confirmValidMatcher = new ConfirmValidMatcher();

  invalidFields: string[] = [];
  invalidMessage: string = 'test';

  transportTypesSelected: DictionaryValue[] = [];
  devices: DictionaryValue[];
  filteredTransportTypes: Observable<DictionaryValue[]>;
  transportTypesCtrl = new UntypedFormControl();
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  clientForm = new UntypedFormGroup({
    client: new UntypedFormControl('', Validators.required),
  });

  canChooseValue = true;
  canAddOtherAddress = true;

  @ViewChild('deviceInput') deviceInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  recurrencies = [
    {
      name: 'Par jour',
      value: 'daily',
    },
    // {
    //   name: 'Par semaine',
    //   value: 'weekly'
    // },
    {
      name: 'Par mois',
      value: 'monthly',
    },
  ];

  daily = [
    {
      name: 'Tous les jours',
      value: 'everyday',
    },
    {
      name: 'Tous les jours de semaine',
      value: 'everyWeekDays',
    },
    {
      name: 'Tous les ...',
      value: 'custom',
    },
  ];

  monthly = [
    {
      name: 'Le',
      value: 'day',
    },
    {
      name: 'Le',
      value: 'the',
    },
  ];

  nthDays = [
    {
      name: 'premier',
      value: 'first',
    },
    {
      name: 'second',
      value: 'second',
    },
    {
      name: 'troisième',
      value: 'third',
    },
  ];

  days = [
    {
      value: 1,
      checked: false,
      disabled: false,
    },
    {
      value: 2,
      checked: false,
      disabled: false,
    },
    {
      value: 3,
      checked: false,
      disabled: false,
    },
    {
      value: 4,
      checked: false,
      disabled: false,
    },
    {
      value: 5,
      checked: false,
      disabled: false,
    },
    {
      value: 6,
      checked: false,
      disabled: false,
    },
    {
      value: 0,
      checked: false,
      disabled: false,
    },
  ];

  daysSelected = [];
  daysWeeklySelected = [];
  isPonctualOrder = false;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private authSrv: AuthService,
    private clientsSrv: ClientsService,
    private ordersSrv: RecurringOrdersService,
    private sitesSrv: SitesService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private router: Router,
    private usersSrv: UsersService,
  ) {
    super(uiSrv, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();

    // tslint:disable-next-line: max-line-length
    this.isRestricted =
      this.authSrv.getUser().role.name !== RoleName.super_admin &&
      this.authSrv.getUser().role.name !== RoleName.bizzdev;
    this.isClient =
      this.authSrv.getUser().role.name === RoleName.client ||
      this.authSrv.getUser().role.name === RoleName.admin_client;
    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor;

    const hasFullAccess = this.authSrv.getUser().role.name === RoleName.bizzdev
      || this.authSrv.getUser().role.name === RoleName.super_admin;

    if (this.isAdmin) {
      let clients = [];
      clients = this.authSrv.getDecodedToken().client.split(',');
      
      if (hasFullAccess) {
        this.canChooseValue = false;
        this.isAdminWithOneClient = false;
      } else if (clients.length > 1) {
        this.canChooseValue = false;
        this.isAdminWithOneClient = false;
      } else {
        this.canChooseValue = true;
        this.isAdminWithOneClient = true;
      }
    }

    // Observer les changements de client
    this.clientForm.get('client').valueChanges.subscribe((client) => {
      if (client && typeof client !== 'string') {
        this.chooseClient(client);
      } else {
        // Client supprimé ou invalide - réinitialiser et masquer le formulaire
        this.selectedClient = null!;
        this.filteredSites = [];
        this.canChooseValue = false;
        if (this.editForm) {
          this.editForm.get('site')!.setValue(null);
        }
      }
    });

    this.initSubscriptions();
  }

  isControlSet(control: string): boolean {
    return !!this.editForm.get(control);
  }

  onFinish(): void {
    this.editFinished.emit();
    this.router.navigate(['/recurring-orders/list']);
  }

  onSubmit(): void {
    // this.isLoading = true;
    this.create();
  }

  private create(): void {
    const formValues = this.editForm.value;
    let cronExpression = null;
    
    if (!this.isPonctualOrder) {
      cronExpression = this.createCronExpression();
    }

    const sitesPromise = new Promise<boolean>((resolve, reject) => {
      if (typeof formValues.site === 'string') {
        if (
          !confirm(
            "Vous n'avez pas sélectionné de donneur d'ordre. Souhaitez-vous en créer un nouveau ?",
          )
        ) {
          resolve(false);
          return;
        }
        console.log('here');

        let newSite = new Site(
          formValues.site,
          [this.urgencyLevels[0].client],
          false,
        );

        this.sitesSrv.post(newSite).subscribe((newSiteFromSrv) => {
          formValues.site = newSiteFromSrv;
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });

    Promise.all([sitesPromise]).then(([response]) => {
      if (!response) {
        return;
      }

      if (typeof formValues.sender.address === 'string') {
        formValues.sender.otherAddress = formValues.sender.address;
        formValues.sender.address = null;
      } else {
        formValues.sender.otherAddress = null;
      }

      if (formValues.type === 'isTour') {
        formValues.sender.isDelivery = true;
        formValues.sender.isPickup = true;
      }

      formValues.receivers.map((receiver) => {
        if (typeof receiver.address === 'string') {
          receiver.otherAddress = receiver.address;
          receiver.address = null;
        } else {
          receiver.otherAddress = null;
        }

        if (formValues.type === 'isTour') {
          receiver.isDelivery = true;
          receiver.isPickup = true;
        } else {
          if (receiver.type === 'isDelivery') {
            receiver.isDelivery = true;
            receiver.isPickup = false;
          } else {
            receiver.isDelivery = false;
            receiver.isPickup = true;
          }
        }
      });

      let callDate = null;

      if (formValues.callDate) {
        let callTime = formValues.callDate.split(':');
        let dateNow = moment(new Date());
        callDate = dateNow
          .hours(callTime[0])
          .minutes(callTime[1])
          .utc()
          .toDate();
      }

      this.order = new RecurringOrder(
        formValues.site,
        formValues.urgencyLevel,
        formValues.ordererPhone,
        formValues.ordererName,
        formValues.sender,
        formValues.receivers,
        this.transportTypesSelected,
        cronExpression ?? undefined,
        this.isPonctualOrder ? 0 : this.minutesToAdd(),
        OrderType.client,
        formValues.ordererComment,
      );

      this.order.client = this.clientForm.get('client')?.value;

      this.order.isActiveOnHolidays = formValues.isActiveOnHolidays;

      this.order.name = formValues.name;
      
      // Gérer les dates pour les commandes ponctuelles
      if (this.isPonctualOrder) {
        if (formValues.scheduledDate && formValues.scheduledTime) {
          const scheduledDateTime = new Date(formValues.scheduledDate);
          const [hours, minutes] = formValues.scheduledTime.split(':');
          scheduledDateTime.setHours(Number.parseInt(hours, 10), Number.parseInt(minutes, 10), 0);
          this.order.scheduledDate = scheduledDateTime;
        }
        
        if (formValues.orderStartDate && formValues.orderStartTime) {
          const orderStartDateTime = new Date(formValues.orderStartDate);
          const [hours, minutes] = formValues.orderStartTime.split(':');
          orderStartDateTime.setHours(Number.parseInt(hours, 10), Number.parseInt(minutes, 10), 0);
          this.order.orderStartDate = orderStartDateTime;
        }
      } else {
        // Pour les commandes récurrentes, s'assurer que les dates sont null
        this.order.scheduledDate = null;
        this.order.orderStartDate = null;
      }

      if (this.order.sender.requestedTime) {
        this.order.sender.requestedTime = this.formatTimeWithSeconds(
          this.order.sender.requestedTime,
        );
      }

      this.order.receivers.forEach((receiver) => {
        if (receiver.requestedTime) {
          receiver.requestedTime = this.formatTimeWithSeconds(
            receiver.requestedTime,
          );
        }
      });

      if (formValues.type === 'isTour') {
        this.order.type = OrderType.tour;
        this.order.code = formValues.code;
        this.order.price = formValues.price;
        this.order.extraStepPrice = formValues.extraStepPrice;

        if (formValues.driver) this.order.driver = formValues.driver;
      }

      this.ordersSrv.post(this.order).subscribe(
        (orderCreated) => {
          this.isLoading = false;
          this.uiSrv.showSnackbar('recurringOrders.create.created', true);
          this.order = orderCreated;
          this.onFinish();
        },
        () => (this.order = null),
      );
    });
  }


  private formatTimeWithSeconds(time: string): string {
    if (!time) {
      return null;
    }
    // Si le format est déjà HH:MM:SS, on le retourne tel quel
    if (time.split(':').length === 3) {
      return time;
    }
    // Sinon, on ajoute :00 pour les secondes
    return time + ':00';
  }

  private initSubscriptions(): void {
    this.isLoading = true;

    const driversPromise = new Promise((resolve, reject) => {
      this.usersSrv.getList(null, true).subscribe((usersFromSrv) => {
        this.drivers = usersFromSrv.filter(
          (user) =>
            user.role.name !== RoleName.admin_client &&
            user.role.name !== RoleName.client,
        );
        resolve(true);
      });
    });

    if (this.canChooseValue) {
      const sitesPromise = new Promise((resolve, reject) => {
        this.sitesSrv.getNonTransmissionOnlyList().subscribe((sitesFromSrv) => {
          this.sites = sitesFromSrv;
          resolve(true);
        });
      });

      const clientsPromise = new Promise((resolve, reject) => {
        this.clientsSrv.getList().subscribe((clientsFromSrv) => {
          this.clients = clientsFromSrv;
          resolve(true);
        });
      });

      const typeTransportsPromise = new Promise((resolve, reject) => {
        this.dictionarySrv.getTransportList().subscribe((transportsFromSrv) => {
          this.allTransportTypes = transportsFromSrv;
          // this.filteredTransportTypes = transportsFromSrv;
          this.filteredTransportTypes =
            this.transportTypesCtrl.valueChanges.pipe(
              startWith(null),
              map((fruit: string | null) =>
                fruit ? this._filter(fruit) : this.allTransportTypes.slice(),
              ),
            );
          resolve(true);
        });
      });

      const urgencyLevelsPromise = new Promise((resolve, reject) => {
        this.dictionarySrv
          .getUrgencyList()
          .subscribe((urgencyLevelsFromSrv) => {
            this.urgencyLevels = urgencyLevelsFromSrv;
            resolve(true);
          });
      });

      const addressPromise = new Promise((resolve, reject) => {
        this.addressesSrv.getList().subscribe((addressessFromSrv) => {
          this.senders = addressessFromSrv.filter(
            (address) => address.isSender,
          );
          this.receivers = addressessFromSrv.filter(
            (address) => address.isReceiver,
          );
          resolve(true);
        });
      });

      Promise.all([
        sitesPromise,
        clientsPromise,
        typeTransportsPromise,
        urgencyLevelsPromise,
        addressPromise,
        driversPromise,
      ]).then(() => {
        this.isLoading = false;
        this.initForm();
        // Si l'utilisateur a une seule agence, la sélectionner dans le formulaire (sans déclencher chooseClient)
        if (this.isAdminWithOneClient && this.clients && this.clients.length === 1) {
          setTimeout(() => {
            this.selectedClient = this.clients[0];
            this.filteredSites = this.sites; // Les sites sont déjà chargés
            this.clientForm.get('client')!.setValue(this.clients[0], { emitEvent: false });
          }, 0);
        }
      });
    } else {
      const clientsPromise = new Promise((resolve, reject) => {
        this.clientsSrv.getList().subscribe((clientsFromSrv) => {
          this.clients = clientsFromSrv;
          resolve(true);
        });
      });

      const addressPromise = new Promise((resolve, reject) => {
        this.addressesSrv.getList().subscribe((addressessFromSrv) => {
          this.senders = addressessFromSrv.filter(
            (address) => address.isSender,
          );
          this.receivers = addressessFromSrv.filter(
            (address) => address.isReceiver,
          );
          resolve(true);
        });
      });

      Promise.all([clientsPromise, addressPromise, driversPromise]).then(() => {
        this.isLoading = false;
      });
    }
  }

  private initForm(): void {
    const startMoment: moment.Moment = moment(new Date());
    const startTime: string = startMoment.add(1, 'hours').format('HH:mm');

    this.editForm = this.fb.group({
      ordererComment: [null, [Validators.maxLength(this.commentMaxLength)]],
      urgencyLevel: new UntypedFormControl(null, [Validators.required]),
      name: new UntypedFormControl(null, [Validators.maxLength(50)]),
      type: ['isClient', Validators.required],
      isPonctual: new UntypedFormControl(false),
      // Champs pour commande ponctuelle
      scheduledDate: new UntypedFormControl(null),
      scheduledTime: new UntypedFormControl(null),
      orderStartDate: new UntypedFormControl(null),
      orderStartTime: new UntypedFormControl(null),
      // Champs pour commande récurrente
      creationTime: new UntypedFormControl(null),
      startTime: new UntypedFormControl(null),
      recurrency: new UntypedFormControl(null),
      dailyRecurrency: new UntypedFormControl(null),
      weeklyRecurrency: new UntypedFormControl(null),
      dayMonthlyRecurrency: new UntypedFormControl(null),
      // monthlyRecurrency: new FormControl(null),
      // nthDayMonthlyRecurrency: new FormControl(null),
      // dayChoosedMonthlyRecurrency: new FormControl(null),
      // nthMonthMonthlyRecurrency: new FormControl(null),
      sender: this.fb.group(
        {
          address: [null, [Validators.required]],
          otherAddress: [null],
          service: [
            null,
            [Validators.required, Validators.maxLength(this.stringMaxLength)],
          ],
          ordererComment: [null, [Validators.maxLength(this.commentMaxLength)]],
          isPickup: [true],
          isDelivery: [false],
          requestedTime: [null],
        },
        Validators.required,
      ),
      receivers: this.fb.array([], Validators.required),
      ordererPhone: new UntypedFormControl(null, [
        Validators.maxLength(this.stringMaxLength),
      ]),
      ordererName: new UntypedFormControl(null, [
        Validators.maxLength(this.stringMaxLength),
      ]),
      site: new UntypedFormControl(null, [Validators.required]),
      isActiveOnHolidays: new UntypedFormControl(true),
    });

    this.onAddReceiver();

    // Gestion du toggle commande ponctuelle
    this.editForm.get('isPonctual').valueChanges.subscribe((isPonctual) => {
      this.isPonctualOrder = isPonctual;
      this.updateFormValidators();
    });

    // reset les jours sélectionnés
    this.editForm.get('recurrency').valueChanges.subscribe(() => {
      this.daysSelected = [];
    });

    this.editForm.valueChanges.subscribe(() => {
      this.invalidFields = [];
      this.invalidFields = this.findInvalidControls();
      this.invalidMessage = 'Le formulaire est incomplet';
      this.invalidFields.map((field) => {
        this.invalidMessage = this.invalidMessage + ' ' + field;
      });
    });

    this.editForm.get('site').valueChanges.subscribe((site) => {
      this.canAddOtherAddress = !site || typeof site === 'string' || site.allowOtherAddress !== false;

      if (site && site.id) {
        this.addressesSrv.getListForSite(site.id).subscribe((addresses) => {
          this.senders = addresses.filter((address) => address.isSender);
          this.receivers = addresses.filter((address) => address.isReceiver);
          this.editForm.get('sender').get('address').setValue(null);
          this.getArray('receivers').controls.forEach((control) => {
            control.get('address').setValue(null);
          });
        });

        const client = this.clientForm.get('client')?.value;

        this.dictionarySrv
          .getTransportListBySite(site, client?.id)
          .subscribe((transports) => {
            this.allTransportTypes = transports;
            this.transportTypesSelected = [];
            this.filteredTransportTypes = of(transports);
          });

        this.dictionarySrv
          .getUrgencyListBySite(site, client?.id)
          .subscribe((urgencyLevels) => {
            this.urgencyLevels = urgencyLevels;
            this.editForm.get('urgencyLevel').setValue(null);
          });
      }
    });

    if (this.isTour()) {
      this.editForm.addControl('driver', new UntypedFormControl());
    }

    this.editForm.get('type').valueChanges.subscribe((value) => {
      if (value === 'isTour') this.onTourSelected();
      else this.onTourUnselected();
    });
  }

  private onTourSelected() {
    this.updateAllStepType('isDelivery');
    this.addTourControls();
  }

  private onTourUnselected() {
    this.removeTourControls();
  }

  private updateAllStepType(type: string): void {
    this.getArray('receivers').controls.forEach((control) => {
      control.get('type').setValue(type);
    });
  }

  private addTourControls(): void {
    this.editForm.addControl('price', new UntypedFormControl());
    this.editForm.addControl('extraStepPrice', new UntypedFormControl());
    this.editForm.addControl('driver', new UntypedFormControl());
    this.editForm.addControl(
      'code',
      new UntypedFormControl(null, [Validators.maxLength(this.codeMaxLength)]),
    );
  }

  private removeTourControls(): void {
    this.editForm.removeControl('price');
    this.editForm.removeControl('extraStepPrice');
    this.editForm.removeControl('driver');
    this.editForm.removeControl('code');
  }

  public findInvalidControls() {
    const invalid = [];

    if (this.editForm.controls) {
      const controls = this.editForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(this.translateFields(name));
        }
      }
    }

    //check si le dernier receiver est bien une livraison
    if (!this.isTour()) {
      let lastReceiver =
        this.editForm.value.receivers[this.editForm.value.receivers.length - 1];

      if (lastReceiver.type === 'isPickup') {
        invalid.push(' | La dernière étape est un enlèvement');
      }
    }

    if (this.transportTypesSelected.length === 0) {
      invalid.push(" | Il n'y a aucun type de produit");
    }
    return invalid;
  }

  translateFields(name): string {
    if (name === 'site') {
      return " | Donneur d'ordre";
    }
    if (name === 'urgencyLevel') {
      return " | Niveau d'urgence";
    }
    if (name === 'sender') {
      return this.isTour()
        ? '| étape 1 incomplète'
        : " | Lieu d'enlèvement incomplet";
    }
    if (name === 'receivers') {
      return this.isTour()
        ? '| étape(s) incomplète(s)'
        : ' | Destinataire(s) incomplet(s)';
    }
    if (name === 'transportType') {
      return ' | Aucun type de produit';
    }
  }

  minTransportType(min = 1): any {
    return (formArray: UntypedFormArray) => {
      return formArray.controls.length >= min ? null : { required: true };
    };
  }

  onAddTransportType(transportType?: Dictionary): void {
    this.transportTypesFields.push(
      this.fb.control(null, [Validators.required]),
    );
  }

  removeTransportType(transportTypeToRemove): void {
    this.getArray('transportTypes').controls.splice(
      this.getArray('transportTypes').controls.indexOf(transportTypeToRemove),
      1,
    );
    this.editForm.value.transportTypes.splice(
      this.editForm.value.transportTypes.indexOf(transportTypeToRemove.value),
      1,
    );
  }

  get transportTypesFields(): UntypedFormArray {
    return this.editForm.get('transportTypes') as UntypedFormArray;
  }

  onAddReceiver(): void {
    const newGroup = this.fb.group({
      address: [null, [Validators.required]],
      otherAddress: [null],
      service: [
        null,
        [Validators.required, Validators.maxLength(this.stringMaxLength)],
      ],
      ordererComment: [null, [Validators.maxLength(this.commentMaxLength)]],
      type: ['isDelivery', [Validators.required]],
      requestedTime: [null],
    });

    this.getArray('receivers').push(newGroup);
  }

  onRemoveReceiver(index: number): void {
    this.getArray('receivers').removeAt(index);
  }

  onCheckboxChange(e): any {
    const checkArray: UntypedFormArray = this.editForm.get(
      'transportTypes',
    ) as UntypedFormArray;

    if (e.checked) {
      checkArray.push(new UntypedFormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.source.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  remove(fruit: DictionaryValue): void {
    const index = this.transportTypesSelected.indexOf(fruit);

    if (index >= 0) {
      this.transportTypesSelected.splice(index, 1);
    }

    this.checkIfSelected();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    document.getElementById('deviceChipList').blur();
    if (!this.transportTypesSelected.includes(event.option.value)) {
      this.transportTypesSelected.push(event.option.value);
      // this.devices = this._filter(event.option.value);
      this.checkIfSelected();

      this.deviceInput.nativeElement.value = '';
    }
  }

  checkIfSelected() {
    this.filteredTransportTypes = this.filteredTransportTypes.pipe(
      map((array) => {
        return array.map((element) => {
          if (this.transportTypesSelected.includes(element)) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          return element;
        });
      }),
    );
  }

  private _filter(value?): DictionaryValue[] {
    let filterValue = '';

    if (value.name) {
      filterValue = value.name.toLowerCase();
      return this.allTransportTypes.filter((el) => {
        return el.id === value.id;
      });
    } else {
      filterValue = value.toLowerCase();
      return this.allTransportTypes.filter(
        (transportType) =>
          transportType.name.toLowerCase().indexOf(filterValue) === 0,
      );
    }
  }

  clearDevicesSelected(): void {
    this.transportTypesSelected = [];
    this.filteredTransportTypes.pipe(
      map((fruit) => {
        return this.allTransportTypes;
      }),
    );
    this.checkIfSelected();
  }

  getClientControl(control: string): UntypedFormControl {
    return this.clientForm.get(control) as UntypedFormControl;
  }

  chooseClient(client) {
    this.isLoading = true;
    this.selectedClient = client;
    let clientId = client.id;
    let clientArray = [clientId];
    this.filteredSites = [];

    // Réinitialiser le site sélectionné
    if (this.editForm) {
      this.editForm.get('site').setValue(null);
      this.editForm.get('urgencyLevel').setValue(null);
    }
    if (this.transportTypesSelected.length > 0) {
      this.transportTypesSelected = [];
    }

    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getNonTransmissionOnlyListByClients(clientArray).subscribe((sitesFromSrv) => {
        this.filteredSites = sitesFromSrv;
        resolve(true);
      });
    });

    const typeTransportsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv
        .getTransportListById2(clientId)
        .subscribe((transportsFromSrv) => {
          this.allTransportTypes = transportsFromSrv;
          this.filteredTransportTypes =
            this.transportTypesCtrl.valueChanges.pipe(
              startWith(null),
              map((fruit: string | null) =>
                fruit ? this._filter(fruit) : this.allTransportTypes.slice(),
              ),
            );

          // this.transportTypesCtrl.valueChanges.subscribe(() => {
          //   this.invalidFields = this.findInvalidControls();
          //   this.invalidFields.map(field => {
          //     this.invalidMessage = this.invalidMessage + ' ' + field;
          //   })
          // })

          resolve(true);
        });
    });

    const urgencyLevelsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv
        .getUrgencyListById2(clientId)
        .subscribe((urgencyLevelsFromSrv) => {
          this.urgencyLevels = urgencyLevelsFromSrv;
          resolve(true);
        });
    });

    Promise.all([
      sitesPromise,
      typeTransportsPromise,
      urgencyLevelsPromise,
    ]).then(() => {
      this.isLoading = false;
      if (!this.canChooseValue) {
        this.canChooseValue = true;
        this.initForm();
      }
    });
  }

  selectDay(event, day) {
    if (event.source.checked === true) {
      day.checked = true;
      this.daysSelected.push(day.value);
    } else {
      day.checked = false;
      this.daysSelected.map((oneDay, index) => {
        if (oneDay === day.value) {
          this.daysSelected.splice(index, 1);
        }
      });
    }
  }

  selectWeeklyDay(event, day) {
    if (event.source.checked === true) {
      day.checked = true;
      this.daysWeeklySelected.push(day.value);
    } else {
      day.checked = false;
      this.daysWeeklySelected.map((oneDay, index) => {
        if (oneDay === day.value) {
          this.daysWeeklySelected.splice(index, 1);
        }
      });
    }
  }

  showDayText(day: Day): string {
    return 'billing.schedules.days.' + Day[day];
  }

  createCronExpression(): string {
    let cronExpression = '';
    let formValues = this.editForm.value;
    let minutes = formValues.creationTime.split(':')[1];
    let hours = formValues.creationTime.split(':')[0];
    cronExpression += minutes + ' ' + hours;

    if (formValues.recurrency === 'daily') {
      if (formValues.dailyRecurrency === 'everyday') {
        cronExpression += ' * * *';
      } else if (formValues.dailyRecurrency === 'everyWeekDays') {
        cronExpression += ' * * 1-5';
      } else if (formValues.dailyRecurrency === 'custom') {
        let days = '';
        this.daysSelected.map((day, index) => {
          if (index === 0) {
            days += day;
          } else {
            days += ',' + day;
          }
        });
        cronExpression += ' * * ' + days;
      }
    } else if (formValues.recurrency === 'weekly') {
      let frequency = '*/' + formValues.weeklyRecurrency;
      let days = '';
      this.daysSelected.map((day, index) => {
        if (index === 0) {
          days += day;
        } else {
          days += ',' + day;
        }
      });

      cronExpression += ' 0 * ' + days;
    } else if (formValues.recurrency === 'monthly') {
      // if (formValues.monthlyRecurrency === 'day') {
      let day = formValues.dayMonthlyRecurrency;
      // let month = formValues.nthMonthMonthlyRecurrency;

      cronExpression += ' ' + day + ' *' + ' *';
      // } else if (formValues.monthlyRecurrency ===  'the') {

      // }
    }

    return cronExpression;
  }

  minutesToAdd(): number {
    const formValues = this.editForm.value;
    
    if (!formValues.creationTime || !formValues.startTime) {
      return 0;
    }

    const minutesCreationTime = Number.parseInt(formValues.creationTime.split(':')[1], 10);
    const hoursCreationTime = Number.parseInt(formValues.creationTime.split(':')[0], 10);
    const totalMinutesCreationTime = hoursCreationTime * 60 + minutesCreationTime;

    const minutesStartTime = Number.parseInt(formValues.startTime.split(':')[1], 10);
    const hoursStartTime = Number.parseInt(formValues.startTime.split(':')[0], 10);
    const totalMinutesStartTime = hoursStartTime * 60 + minutesStartTime;

    const minutesToAdd = totalMinutesStartTime - totalMinutesCreationTime;

    return minutesToAdd;
  }

  public isTour(): boolean {
    return this.getControl('type').value === 'isTour';
  }

  isTypeOf(type: string, value: any): boolean {
    return typeof value === type;
  }

  private updateFormValidators(): void {
    if (this.isPonctualOrder) {
      // Commande ponctuelle : dates requises, récurrence non requise
      this.editForm.get('scheduledDate').setValidators([Validators.required]);
      this.editForm.get('scheduledTime').setValidators([Validators.required]);
      this.editForm.get('orderStartDate').setValidators([Validators.required]);
      this.editForm.get('orderStartTime').setValidators([Validators.required]);
      
      this.editForm.get('creationTime').clearValidators();
      this.editForm.get('startTime').clearValidators();
      this.editForm.get('recurrency').clearValidators();
    } else {
      // Commande récurrente : récurrence requise, dates non requises
      this.editForm.get('creationTime').setValidators([Validators.required]);
      this.editForm.get('startTime').setValidators([Validators.required]);
      
      this.editForm.get('scheduledDate').clearValidators();
      this.editForm.get('scheduledTime').clearValidators();
      this.editForm.get('orderStartDate').clearValidators();
      this.editForm.get('orderStartTime').clearValidators();
    }
    
    // Mettre à jour la validation
    this.editForm.get('scheduledDate').updateValueAndValidity();
    this.editForm.get('scheduledTime').updateValueAndValidity();
    this.editForm.get('orderStartDate').updateValueAndValidity();
    this.editForm.get('orderStartTime').updateValueAndValidity();
    this.editForm.get('creationTime').updateValueAndValidity();
    this.editForm.get('startTime').updateValueAndValidity();
    this.editForm.get('recurrency').updateValueAndValidity();
  }
}
